<div class="row row-sm add-form">
    <form autocomplete="off" class="p-0" novalidate>
        <div class="col-lg-12 col-md-12">
            <div class="card-body mb-2">
                <div class="bc d-flex align-items-center pl-3">
                    <div class="ml-2">
                        <h3 class="main-content-label mb-1"><b>
                             Eligibility Rule
                            </b></h3>
                    </div>
                </div>
               
                <div class="mt-3">
                    <table class="table table-bordered text-nowrap">
                        <thead>
                            <tr>
                                <th class="f600">Rule Name</th>
                              
                                <th class="f600">Rule Description</th>
                                <th class="f600">Remark</th>
                                <th class="f600">Rule Result</th>
                            </tr>
                        </thead>
                        <tbody id="table_data">
                            <tr *ngFor="let exam of examList">
                                <td [style.color]="exam.Remark == 'Failed' ? 'red' : 'green'">{{ exam.RuleName }}</td>
                                <td [style.color]="exam.Remark == 'Failed' ? 'red' : 'green'">{{ exam.RuleDescription }}</td>
                                <td [style.color]="exam.Remark == 'Failed' ? 'red' : 'green'">{{ exam.Remark }}</td>
                                <td [style.color]="exam.Remark == 'Failed' ? 'red' : 'green'" *ngIf="exam.Remark === 'Passed'">
                                    Eligible
                                </td>
                                <td [style.color]="exam.Remark == 'Failed' ? 'red' : 'green'" *ngIf="exam.Remark === 'Failed'">
                                    Not Eligible
                                </td>
                                <!-- <td>
                                    <mat-icon *ngIf="exam.RuleResult === 'Passed'" style="color: green;">check_circle</mat-icon>
                                    <mat-icon *ngIf="exam.RuleResult === 'Failed'" style="color: red;">cancel</mat-icon>
                                </td> -->
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </form>
</div>

<mat-dialog-actions class="mat-dialog-actions">
    <div class="col text-center pb-3">
        <div class="row">
            <div class="col-lg-12 col-sm-12 justify-content-center text-left">
             
                <button mat-raised-button mat-dialog-close="Continue" [disabled]="CountinuButton" tabindex="1" type="button" id="Continue"
                    class="btn btn-primary center-block w-70 my-2 me-2">
                    Continue
                </button>
                <!-- [disabled]="!CountinuButton"  -->
                <button (click)="SelectData('Back')" mat-raised-button mat-dialog-close="Back" tabindex="-1" type="button" id="Back"
                    class="btn btn-default center-block w-70 ml-3">
                    Back 
                </button>
            </div>
        </div>
    </div>
</mat-dialog-actions>
